import React from 'react';
import { useSchool } from '../contexts/SchoolContext';

// The policy text is supplied by the school and edited under Admin > School Settings. Until it is entered the page
// says so honestly instead of showing invented text.
const Privacy = () => {
  const { settings } = useSchool();
  const paragraphs = (settings.privacy_policy || '').split(/\n\s*\n/).map((p) => p.trim()).filter(Boolean);

  return (
    <div className="privacy-page">
      <section className="section">
        <div className="container" style={{ maxWidth: 800 }}>
          <h1>Privacy Policy</h1>
          {paragraphs.length > 0 ? (
            paragraphs.map((text, i) => (
              <p key={i} style={{ whiteSpace: 'pre-line' }}>{text}</p>
            ))
          ) : (
            <p>
              Our privacy policy is being finalised. If you have questions about how we handle your family&rsquo;s
              information, please contact us
              {settings.email_admissions && (
                <> at <a href={`mailto:${settings.email_admissions}`}>{settings.email_admissions}</a></>
              )}
              .
            </p>
          )}
        </div>
      </section>
    </div>
  );
};

export default Privacy;
